import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { appStyle } from "../theme/appStyle";
import listingCardGeneralStyles from "../theme/listingCardGeneralStyles";
import { PAGES_SLUGS } from "../constants";
import { useSelector } from 'react-redux';
import _get from 'lodash/get';

function TestDriveCard() {
  const classes = useStyles();

  const pageData = useSelector(state => _get(state.pages.data, PAGES_SLUGS.PRODUCTS, {}));
  const pageContent = _get(pageData, 'data.ro', {});

  const title = _get(pageContent, 'highlight_card_title', '');
  const description = _get(pageContent, 'highlight_card_description', '');
  const buttonText = _get(pageContent, 'button_text', '');
  const buttonUrl = _get(pageContent, 'button_url', '');
  const imageUrl = _get(pageContent, 'highlight_image', '');

  return (
    <Card elevation={0} className={classes.testDriveCard}>
      <div className={classes.imageContainer}>
        <img
          src={imageUrl}
          alt={title}
          className={classes.cardImage}
        />
      </div>
      <div className={classes.overlay}>
        <Typography variant="h4" className={classes.testDriveTitle}>
          {title}
        </Typography>
        <Typography variant="body1" className={classes.testDriveDescription}>
          {description}
        </Typography>
        <Button
          component={Link}
          to={buttonUrl}
          variant="contained"
          className={classes.testDriveButton}
        >
          {buttonText}
        </Button>
      </div>
    </Card>
  );
}

export default TestDriveCard;

const useStyles = makeStyles((theme) => ({
  ...appStyle(theme),
  ...listingCardGeneralStyles(theme),
  testDriveCard: {
    height: '100%',
    position: 'relative',
    borderRadius: '4px',
    overflow: 'hidden',
  },
  imageContainer: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    [theme.breakpoints.down('md')]: {
      position: 'static',
    },
  },
  cardImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 100%)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    padding: theme.spacing(2),
  },
  testDriveTitle: {
    color: '#ffffff',
    fontSize: '30px',
    fontWeight: 400,
    maxWidth: '65%',
    marginBottom: theme.spacing(2),
  },
  testDriveDescription: {
    color: '#ffffff',
    fontSize: '14px',
    maxWidth: '90%',
    marginBottom: theme.spacing(3),
    opacity: 0.9,
  },
  testDriveButton: {
    backgroundColor: '#ffffff',
    color: '#1c6bba',
    padding: '12px 24px',
    borderRadius: '3px',
    textTransform: 'none',
    fontWeight: 700,
    fontSize: '15px',
    lineHeight: '26.25px',
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
    alignSelf: 'flex-start',
  },
}));
